import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-button-new',
    template: `
    <button *ngIf="active" type="button" class="btn btn-info btn-{{ size }}" (click)="navigateCreate()">
      <i class="fa fa-plus"></i> {{ title | translate }}
    </button>
  `,
    standalone: false
})
export class ButtonNewComponent {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  @Input() route = '..';

  @Input() size = 'sm';

  @Input() title = 'new';

  @Input() queryParams = {};

  @Input() active = false;

  @Input() openModal: boolean = false;

  @Output() openCreateModal = new EventEmitter();

  public navigateCreate(key) {
    if (this.openModal) {
      this.openCreateModal.emit();
    } else {
      this.router.navigate([this.route],
        {
          relativeTo: this.activatedRoute,
          queryParams: this.queryParams
        });
    }
  }
}

